import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth, AuthProvider } from "./context/AuthContext";
import "./styles/global.css";
import Navbar         from "./components/Navbar";
import Footer         from "./components/Footer";
import HomePage       from "./pages/HomePage";
import AboutPage      from "./pages/AboutPage";
import ProgramsPage   from "./pages/ProgramsPage";
import MembershipPage from "./pages/MembershipPage";
import ImpactPage     from "./pages/ImpactPage";
import ApplyPage      from "./pages/ApplyPage";
import LoginPage      from "./pages/LoginPage";
import DashboardPage  from "./pages/DashboardPage";
import AdminDashboard from "./pages/AdminDashboard";
import ContactPage    from "./pages/ContactPage";
import TermsPage      from "./pages/TermsPage";

function PublicRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/dashboard" replace /> : children;
}

function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ fontSize: 32, animation: "spin 1s linear infinite" }}>⟳</div>
    </div>
  );
  return currentUser ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { currentUser, userProfile, loading } = useAuth();
  if (loading) return null;

  const isHardcodedAdmin = sessionStorage.getItem("isAdminSession") === "true";
  if (isHardcodedAdmin) return children;

  const isAdmin = currentUser?.email === "doctor002x@gmail.com" || userProfile?.role === "admin";

  if (!currentUser) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function Layout() {
  const location = useLocation();
  const hideLayout = ["/login", "/dashboard", "/admin"].some(p => location.pathname.startsWith(p));
  return (
    <>
      {!hideLayout && <Navbar />}
      <main style={{ paddingTop: hideLayout ? 0 : 70 }}>
        <Routes>
          <Route path="/"           element={<HomePage />} />
          <Route path="/about"      element={<AboutPage />} />
          <Route path="/programs"   element={<ProgramsPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/impact"     element={<ImpactPage />} />
          <Route path="/contact"    element={<ContactPage />} />
          <Route path="/terms"      element={<TermsPage />} />
          <Route path="/login"      element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/apply"      element={<PrivateRoute><ApplyPage /></PrivateRoute>} />
          <Route path="/dashboard"  element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/admin"      element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="*"           element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!hideLayout && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </AuthProvider>
  );
}
